import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, OnInit, Inject, Input } from '@angular/core';
import { I } from '@angular/cdk/keycodes';

@Component({
  selector: 'app-bix-comfirm',
  templateUrl: './bix-comfirm.component.html',
  styleUrls: ['./bix-comfirm.component.scss']
})
export class BixComfirmComponent implements OnInit {
  cancleShow = true;
  message;
  buttonText = 'Confirm';
  cancelText = 'Cancel';
  constructor(public dialogRef:MatDialogRef<BixComfirmComponent>, @Inject(MAT_DIALOG_DATA) public data) {
    console.log(data.cancleShow,'ss');
    
    this.message = data.message;
    if(data.buttonText){
      this.buttonText = data.buttonText;
    }
    if(data.cancelText){
      this.cancelText = data.cancelText;
    }
    if(data.cancleShow == false) {
      this.cancleShow = data.cancelShow
    }
   }

  ngOnInit() {
  }

  closePopup(data=false){
    this.dialogRef.close(data);
  }

}
